import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

// load the application only after loading the shared
Promise.all([import("iqHub/shared")])
  .then(() => import("./App"))
  .then(({ AppInitializer }) => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(<AppInitializer />);
    reportWebVitals();
  })
  .catch((err) => {
    console.log(err.message);
  });
